import React, { useCallback, useEffect } from 'react';
import cn from 'classnames';

import { toUSD } from 'helpers/NumberFormats';
import useMartyContext from 'hooks/useMartyContext';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';

import css from 'styles/components/search/sponsoredProducts.scss';

const SponsoredProducts = ({
  onHeartClick,
  showHearting,
  hearts,
  msaImageParams,
  showRatingStars,
  layoutStyle,
  hydraVadsNoBox,

  hydraVadsNoBoxTopRow,
  heartsList,
  heartsData,
  sponsoredProducts,
  searchTerm,
  trackSponsoredProductEvent
}) => {
  const { testId, marketplace: { shortName } } = useMartyContext();
  const additionalMelodyCardProductClasses = { container: cn(css.product, { [css.secondRow]: hydraVadsNoBox, [layoutStyle]: hydraVadsNoBoxTopRow || hydraVadsNoBox, [css.firstRow]: hydraVadsNoBoxTopRow }) };

  const handleSponsoredProductClick = useCallback(({ index, styleId, adId }) => () => {
    trackSponsoredProductEvent({ eventType: 'click', styleId, adId, searchTerm, index });
  }, [searchTerm, trackSponsoredProductEvent]);

  useEffect(() => {
    trackSponsoredProductEvent({ eventType: 'view', searchTerm });
  }, [searchTerm, trackSponsoredProductEvent]);

  const makeProducts = () => sponsoredProducts.styles.map((product, index) => {
    // Massage data for price formatting
    const cardData = {
      ...product,
      price: toUSD(product.price),
      originalPrice: toUSD(product.originalPrice),
      isSponsored: true
    };
    return (
      <MelodyCardProduct
        key={product.styleId}
        onComponentClick={handleSponsoredProductClick({ index, styleId: product.styleId, adId: sponsoredProducts.adId })}
        componentStyle="searchProductInlineRecos"
        heartsData={heartsData}
        showFavoriteHeart={showHearting}
        hydraVads={hydraVadsNoBox || hydraVadsNoBoxTopRow}
        onHeartClick={onHeartClick}
        hearts={hearts}
        additionalClasses={additionalMelodyCardProductClasses}
        cardData={cardData}
        msaImageParams={msaImageParams}
        melodyCardTestId={testId('searchResultsSponsoredProducts')}
        showRatingStars={showRatingStars}
        heartsList={heartsList}
      />
    );
  });

  if (!hydraVadsNoBox && !hydraVadsNoBoxTopRow) {
    return (
      <aside className={css.searchSponsoredProductsContainer}>
        <h2 className={css.title}>Sponsored Products</h2>
        <Tooltip
          content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
          wrapperClassName={css.tooltipWrapper}
          tooltipClassName={css.tooltip}
          direction="down"
          sponsored={true}
          tooltipId="sponsoredProducts"
        >
          <MoreInfo />
        </Tooltip>
        <div className={css.products}>
          {makeProducts()}
        </div>
      </aside>
    );
  }
  return (
    <>
      {makeProducts()}
    </>
  );
};

export default SponsoredProducts;
